import React from 'react';
import { Outlet } from 'react-router-dom';

import Footer from '../footer/Footer';
import './mainLayOut.css';
import Header from '../header/Header';

const MainLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col w-full" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' }}>
      <Header />
      
      <main className="flex-grow w-full pt-16">
        {children || <Outlet />}
      </main>

      <Footer />
    </div>
  );
};

export default MainLayout;